export enum EDiscountType {
  DISCOUNT = "desconto",
  BILLING = "faturamento",
}
